import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import AnnotateAssetActionModalContainer from './AnnotateAssetActionModalContainer';
import {setProductassetAnnotateAssetModal} from '../../../../store/slice/PharmaSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '95%', xs: '95%' },
  height: { lg: '95%', xs: '95%' },
  borderRadius: 3,
  p: 1,
  backgroundColor:'secondary.lighter',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export default function AnnotateAssetActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {AnnotateAssetModalOpen, productassetObj} = useSelector((state)=>state.pharmaslice.productassetDashboard);

  useEffect(()=>{
  },[AnnotateAssetModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setProductassetAnnotateAssetModal(false));
  }
  return (
    <Modal
       open={AnnotateAssetModalOpen===undefined?false:AnnotateAssetModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              Annotate Asset @ {productassetObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item paddingTop={1} sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}> 
            < AnnotateAssetActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}
